import { Title } from "@mantine/core";

const MantineTitle = (props: any) => {
    const { textWrap, children, className, size, order, ps, py } = props;
    return (
        <Title
            className={className}
            textWrap={textWrap}
            size={size}
            order={order}
            ps={ps}
            py={py}
        >
            {children}
        </Title>
    );
};

export default MantineTitle;